import Link from 'next/link';

type TLinkButtonProps = {
    href: string;
    label: string;
};

export const LinkButton = ({ href, label }: TLinkButtonProps) => {
    return (
        <div className="flex flex-1 px-2.5 lg:w-1/2 lg:pr-20">
            <Link href={href} passHref>
                <a
                    className="tx-medium-medium flex min-h-full w-full items-center justify-center rounded-full border border-green-normal px-4 py-4 text-center !text-green-normal transition-colors hover:bg-green-normal hover:!text-white hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-light"
                    data-test-id="View_more_btn"
                >
                    <span className="truncate">{label}</span>
                </a>
            </Link>
        </div>
    );
};
